<template>
  <div class="">
    <slide-over-panel v-if="alarmSetting !== null"
                v-model:show="$data._show"
                @update:show="updateShow($data._show)">
      <template #title>
        <div class="flex items-center">
          <span>Alarm Setting Information</span>
        </div>
      </template>

      <template #content>

        <div class="">
          <span class="text-lg text-gray-900 text-left font-semibold">Area</span>
        </div>

        <div class="">
          <span class="text-lg text-gray-900 text-left">{{ alarmSetting.area }}</span>
        </div>

        <div class="mt-6">
          <span class="text-lg text-gray-900 text-left font-semibold">Zone</span>
        </div>
        <div class="">
          <span class="text-lg text-gray-900 text-left">{{ alarmSetting.zone }}</span>
        </div>

        <div class="mt-4 pb-4"
             v-show="$data._show">
          <span class="text-lg text-gray-900 text-left font-semibold">Users</span>
          <!--                  Note: We purposely don't v-model the groupUsersArray, we just v-bind it since it's computed -->
          <div      v-if="permissions.can('edit_alarm_settings')">
              <select2
                  :multiple="true"
                  :name="'usersOnAlarm'"
                  :options="availableUsersArray"
                  :value="alarmUsersArray"
                  @input="updateUsers"
              >
              </select2>
          </div>
          <div      v-else-if="permissions.can('view_alarm_settings')">
              <div v-for="userIds in alarmUsersArray">
                <span class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-blue-100 text-blue-800">
                    {{  availableUsersArray[userIds] }}
                </span>
              </div>

          </div>
        </div>

          <green-button @click="save"
          >
            <div v-if="processing"
                 class="inline-flex">
              <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
              <span class="pl-4">Processing</span>
            </div>
            <div v-else
                 class="inline-flex">
              <span>Save Changes</span>
            </div>
          </green-button>

      </template>
    </slide-over-panel>

    <!--    Notification modal for the results -->
    <notification-modal
        v-model:is-open="showResultModal"
    >
      <template #title-content>
        Update Successful!
      </template>
      {{ modalText }}
    </notification-modal>

  </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SlideOverPanel from '@/components/elements/SlideOverPanel';
import GreenButton from '@/components/elements/green-button';
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import Select2 from '@/components/elements/select2';
import ButtonRedPrimary from "@/components/elements/buttons/ButtonRedPrimary";
import ButtonAjax from "@/components/elements/buttonAjax";
import NotificationModal from "@/components/elements/NotificationModal";
import SonicuButton from "@/components/elements/buttons/SonicuButton";

export default {
  name: "AlarmSettingsEdit",
  mixins: [SonicuCoreMixin, iconNamesMixin],
  components: {
    SonicuButton,
    NotificationModal, ButtonAjax, ButtonRedPrimary, SmallColoredCheck, SlideOverPanel, GreenButton, Select2},
  props: {
    alarmSetting: Object,
    show: Boolean,
  },
  data() {
    return {
      _show: this.show,
      usersToSubmit: {},
      processing: false,
      showResultModal: false,
      showConfirmModal: false,
      modalText: '',
      setting: {}
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    updateShow(show) {
      this.$data._show = show
      this.$emit('update:show', this.$data._show)
    },
    save() {
      console.log('saving');
      this.processing = true;
        axios.post(this.company.buildCompanyApiInternalRoute('alarm-settings'), {
          zone_id: this.alarmSetting.zone_id,
          users: this.usersToSubmit,
        }).then(response => {
              this.isAddingGroup = false;
              this.modalText = 'Alarm Setting updated successfully!'
              this.showResultModal = true;
              this.updateAlarmUsers();
              this.$emit('update:setting', this.setting);
              this.processing = false;
            }
        ).catch(error => {
          this.processing = false;
        })


    },
    updateAlarmUsers(){
      this.setting.active_alarm_users = {};
      for (const [key, value] of Object.entries(this.usersToSubmit)) {
        this.setting.active_alarm_users[value] = this.setting.available_users[value][1];
      }
    },
    updateUsers() {
      let newUsers = [];
      let elementName = "usersOnAlarm"
      let val = $('[name=' + elementName + ']').val()
      val.forEach((item) => {
        newUsers.push(this.availableUsersIDsArray[item]);
      })
      this.usersToSubmit = newUsers;
    },
    getUserIDs(){
      var userIDs = []
      for(var key in this.alarmSetting.users){
        userIDs.push(key)
      }
      return userIDs;
    }
  },
  computed: {
    alarmUsersArray() {
      var userIDs = []
      var i = 0;
      for (const [key, value] of Object.entries(this.alarmSetting.available_users)) {
        if(Object.keys(this.alarmSetting.active_alarm_users).includes(String(value[0]))){
          userIDs.push(i);
        }
        i++;
      }
      return userIDs;
    },
    availableUsersArray() {
      var userIDs = []
      for (const [key, value] of Object.entries(this.alarmSetting.available_users)) {
          userIDs.push(value[1]);
      }
      return userIDs;
    },
    availableUsersIDsArray() {
      var userIDs = []
      for (const [key, value] of Object.entries(this.alarmSetting.available_users)) {
        userIDs.push(value[0]);
      }
      return userIDs;
    }
  },
  watch: {
    show() {
      this.$data._show = this.show;
    },
    alarmSetting: function (newVal, oldVal) {
      console.log('updating');
      console.log(newVal);
      this.setting = _.clone(newVal);
    },
    showResultModal: function(newVal, oldVal) {
      if(newVal === false){
        this.updateShow(false);
      }
    }
  },
}

</script>

<style scoped>

</style>